import React, { FC, useEffect } from 'react';
import { VIEW_MODE } from '../../utils/helpers';
import s from './ToolBar.scss';
import { WixLogo } from '../partials/WixLogo/WixLogo';
import { WithTranslation, withTranslation } from '@wix/wix-i18n-config';
import { useTemplateContext } from '../../context/TemplateContext/TemplateContext';
import { InfoButton } from '../InfoButton/InfoButton';
import { useUIContext } from '../../context/UIContext/UIContext';
import { reportEditorClick } from '../../utils/bi';

const ToolBarCmp: FC<WithTranslation> = ({ t }) => {
  const { viewMode, toggleViewMode } = useUIContext();
  const { template } = useTemplateContext();

  useEffect(() => {
    window.templateEditUrl = template.editorUrl; // Adoric need to have this link in the window
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEditorClick = () => {
    reportEditorClick({ origin: 'viewer_top' });
  };

  return (
    <div data-hooks="tool-bar" className={s.toolBar}>
      <div className={s.elementsGroup}>
        <WixLogo />
        <div className={s.elementsGroup}>
          <button
            data-hooks="desktop-view"
            className={`${s.desktopIcon} ${viewMode === VIEW_MODE.DESKTOP ? s.selected : ''}`}
            onClick={() => (viewMode === VIEW_MODE.DESKTOP ? '' : toggleViewMode(VIEW_MODE.DESKTOP))}
          >
            <span className={s.hide}>{t('a11y.desktop.button')}</span>
          </button>
          <hr className={s.hr} />
          <button
            data-hooks="mobile-view"
            className={`${s.mobileIcon} ${viewMode === VIEW_MODE.MOBILE ? s.selected : ''}`}
            onClick={() => (viewMode === VIEW_MODE.MOBILE ? '' : toggleViewMode(VIEW_MODE.MOBILE))}
          >
            <span className={s.hide}>{t('a11y.mobile.button')}</span>
          </button>
        </div>
      </div>
      <div className={`${s.elementsGroup} ${s.actionMenu}`}>
        <p data-hooks="tool-bar-title" className={s.title}>
          {t('template.viewer.title')}
        </p>
        <InfoButton />
        <a
          className={s.button}
          data-hooks="editor-link"
          href={template.editorUrl}
          // eslint-disable-next-line react/jsx-no-target-blank
          target="_blank"
          tabIndex={0}
          onClick={() => onEditorClick()}
        >
          {t('template.viewer.edit.button')}
        </a>
      </div>
    </div>
  );
};

export const ToolBar = withTranslation()(ToolBarCmp);
